import { ArrowRight } from 'lucide-react'
import { getTimeLeft } from '../utils/getTimeLeft'
import { propFirmData } from '../data/propFirmDataHomepage'
import { glassCTAData } from '../data/glassCTAData'
import { propFirmLogos } from '../data/propFirmLogos'
import { PromoCTAButton } from './PromoCTAButton'

interface GlassCTAProps {
  firmId: string
  firm?: any
  discount?: any
  variant?: 'primary' | 'secondary' | 'compact'
  position?: 'top' | 'bottom'
  promoUsedElsewhere?: boolean
}

export function GlassCTA({
  firmId,
  firm,
  discount,
  variant = 'primary',
  position = 'top',
  promoUsedElsewhere = false
}: GlassCTAProps) {
  if (!firmId) return null

  const fallbackFirm = propFirmData[firmId]
  const displayFirm = firm || fallbackFirm
  const displayDiscount = discount || fallbackFirm?.evaluation?.discount || {}

  const { code: promoCode, validUntil } = displayDiscount || {}
  const timeLeft = validUntil ? getTimeLeft(validUntil) : null
  const adData =
    glassCTAData[firmId] ||
    glassCTAData.noMatch ||
    glassCTAData.default

  const logo = propFirmLogos[firmId]?.logo

  const headline =
    variant === 'promo'
      ? adData.promoHeadline
      : position === 'bottom'
        ? adData.bottomHeadline
        : adData.topHeadline

  const description =
    variant === 'promo'
      ? adData.promoDescription
      : position === 'bottom'
        ? adData.bottomDescription
        : adData.topDescription

  return (
    <div className={`glass-cta ${variant} ${position}`}>
      <div className="cta-content">
        {logo && <img src={logo} alt={firmId} className="firm-logo" />}

        <h3 className="headline">{headline}</h3>

        <p className="description">{description}</p>

        <div className="promo">
          {promoCode ? (
            <>
              Use code: <span className="promo-code">{promoCode}</span>
            </>
          ) : (
            <>{adData.defaultText}</>
          )}
        </div>

        {timeLeft && (
          <div className="countdown text-yellow-300">
            {timeLeft} left!
          </div>
        )}

        <PromoCTAButton
          firmId={firmId}
          discount={displayDiscount}
          variant="homepage"
        >
          {promoCode ? 'Get Funded Now →' : `${adData.defaultText} →`}
        </PromoCTAButton>
      </div>
    </div>
  )
}

export default GlassCTA
